import { useEffect, useState } from "react";

import { pad2, splitCountdown } from "./van-khi-style";

/**
 * Đồng hồ đếm ngược neo theo GIỜ SERVER.
 *
 * Đồng hồ máy người dùng có thể lệch (múi giờ sai, chạy nhanh/chậm) nên không
 * dùng Date.now() trực tiếp: lấy độ lệch server↔client một lần rồi bù vào.
 */
export function useServerNow(serverTime: string | undefined): number {
  const [offset, setOffset] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!serverTime) return;
    const parsed = Date.parse(serverTime);
    if (!Number.isNaN(parsed)) setOffset(parsed - Date.now());
  }, [serverTime]);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return now + offset;
}

const CELL = "flex min-w-[62px] flex-col items-center rounded-xl bg-background/70 px-3 py-2";

export function VanKhiCountdown({
  targetIso,
  serverNow,
  label = "Kỳ tiếp theo mở sau",
}: {
  targetIso: string;
  serverNow: number;
  label?: string;
}) {
  const target = Date.parse(targetIso);
  if (Number.isNaN(target)) return null;
  const { days, hours, minutes, seconds } = splitCountdown(target - serverNow);

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="text-xs tracking-wide text-muted-foreground">{label}</p>
      <div className="flex items-center gap-2">
        {[
          { value: days, unit: "NGÀY" },
          { value: hours, unit: "GIỜ" },
          { value: minutes, unit: "PHÚT" },
          { value: seconds, unit: "GIÂY" },
        ].map((cell) => (
          <div key={cell.unit} className={CELL}>
            <span className="font-display text-2xl font-semibold text-primary">
              {pad2(cell.value)}
            </span>
            <span className="text-[10px] tracking-[0.18em] text-muted-foreground">{cell.unit}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
